module.exports = __webpack_public_path__ + "static/media/InDruck.4204a97b.svg";